import React, { useContext, useCallback } from "react";
import _ from "lodash";
import { wizardProps } from "@xengage/gw-portals-wizard-react";
import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import { useValidation } from "@xengage/gw-portals-validation-react";
import { readViewModelValue } from "@xengage/gw-jutro-adapters-react";
import { withRouter } from "react-router-dom";
import metadata from "./ProductandCoverageSelectionComponent.metadata.json5";

import styles from "../DirectorsAndOfficers.module.scss";
import { useTranslator } from "@jutro/locale";
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ProductandCoverageSelectionComponent(props) {
  const { submissionVM, updateWizardData, pathUpdated } = props;
  const breakpoint = useContext(BreakpointTrackerContext);
  const { onValidate } = useValidation("ProductandCoverageSelectionComponent");
  const modelVM = _.get(submissionVM, pathUpdated);
  const translator = useTranslator()

  modelVM.value.isValidationReq = true;

  const setBasOnIsThiAConStrCor = useCallback((value) => {
    if (value) {
      _.set(modelVM, "pplproductType.value", "smart");
      _.set(submissionVM, "lobData.proLine.coverables.dirAndOffProfessionalCoverable.businessOperations.typOfOrg3.value", "nonProfit");
    } else {
      _.set(modelVM, "pplproductType.value", "comSol");
      _.set(submissionVM, "lobData.proLine.coverables.dirAndOffProfessionalCoverable.businessOperations.typOfOrg3.value", "forProfit");
    }

  }, [modelVM, submissionVM]);

  const getAvailableValuesforProductType = useCallback(() => {
    const availableValuesofProductType = _.get(modelVM, 'pplproductType.aspects.availableValues[0].typelist.filters')
    const result = availableValuesofProductType?.filter((typecode) => typecode.name === 'DnOProdType')
    
    if(_.isEmpty(result)){
      return []
    }

    const res = result[0]?.codes?.map((typeCode) => ({
        code: typeCode.code,
        name: translator({
          id: typeCode.name,
          defaultMessage: typeCode.name
        })
    }))

    return res;
  }, [modelVM, translator])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
    "@field": {
      showRequired: true,
      labelPosition: breakpoint === "desktop" ? "left" : "top",
    },
    doYouReqEmpPraLia5: {
      disabled:
        _.get(modelVM, 'pplproductType.value', '') !== undefined &&
        _.get(modelVM, 'pplproductType.value.code', '') === "smart",
    },
    pPLProductType: {
      availableValues: getAvailableValuesforProductType(),
      defaultValue: 'comSol'
    },
    comGenLia3: {
      readOnly: !_.isUndefined(_.get(modelVM.value, 'isThiAConStrCor6')) && _.get(modelVM.value, 'isThiAConStrCor6')
    },
    pro2: {
      readOnly: !_.isUndefined(_.get(modelVM.value, 'isThiAConStrCor6')) && _.get(modelVM.value, 'isThiAConStrCor6')
    }
  };

  const resolvers = {
    resolveCallbackMap: {
      onValidate,
    },
    resolveComponentMap: {},
    resolveClassNameMap: styles,
  };

  const readValue = useCallback(
    (id, path) =>
      readViewModelValue(
        metadata.componentContent,
        _.get(submissionVM, pathUpdated),
        id,
        path,
        overrideProps
      ),
    [overrideProps, pathUpdated, submissionVM]
  );

  const handleValueChange = useCallback(
    (value, changedPath) => {
      const fullPath = `${pathUpdated}.${changedPath}`;

      _.set(submissionVM, `${fullPath}`, value);

      if (changedPath === 'isThiAConStrCor6') {
        _.set(submissionVM, "lobData.proLine.coverables.dirAndOffProfessionalCoverable.businessOperations.typOfOrg3.value", "nonProfit");
        _.set(submissionVM.value, 'lobData.proLine.coverables.dirAndOffProfessionalCoverable.condoCorporation.isValidationReq', true)
        
        if(value) {
          _.set(modelVM.value, 'pro2', false)
          _.set(modelVM.value, 'comGenLia3', false)
        } else {
          const pplproductTypeValue = _.get(modelVM.value, 'pplproductType');

          if (pplproductTypeValue === '2smart') {
            _.set(modelVM.value, 'pro2', true);
          }
        }
      }

      if(changedPath === 'pro2') {
        _.set(modelVM, 'pplproductType.value', '2smart')
      }

      if (changedPath === 'pplproductType') {
        const pplproductTypeValue = _.get(modelVM.value, 'pplproductType');

        if (pplproductTypeValue === 'smart') {
          _.set(modelVM.value, 'doYouReqEmpPraLia5', false);
        }

        if (pplproductTypeValue === '2smart') {
          _.set(modelVM.value, 'pro2', true);
        } else {
          _.set(modelVM.value, 'pro2', false);
        }
      }

      updateWizardData(submissionVM);
    },
    [modelVM, pathUpdated, submissionVM, updateWizardData]
  );

  return (
    <ViewModelForm
      uiProps={metadata.componentContent}
      model={modelVM}
      resolveValue={readValue}
      overrideProps={overrideProps}
      onValidationChange={onValidate}
      onValueChange={handleValueChange}
      callbackMap={resolvers.resolveCallbackMap}
      componentMap={resolvers.resolveComponentMap}
      classNameMap={resolvers.resolveClassNameMap}
    />
  );
}

ProductandCoverageSelectionComponent.propTypes = wizardProps;
export default withRouter(ProductandCoverageSelectionComponent);
